import React from 'react';
import classnames from 'classnames';

interface IVerticalLineProps {
  className?: string;
  height: string;
  color: string;
  borderWidth?: number;
  borderRadius?: number;
}

export const VerticalLine: React.FC<IVerticalLineProps> = ({ className, height, color, borderWidth = 1, borderRadius = 0 }) => {
  return (
    <div
      style={{ height, borderColor: color, borderWidth: `${borderWidth}px`, borderRadius: `${borderRadius}px` }}
      className={classnames('border-l border-solid', className)}
    ></div>
  );
};
